const location = {
  title: 'Permita acesso à localização',
  description: 'Este é um requisito de segurança deste processo de assinatura.',
  action: 'Avançar',
  error: 'Ative a localização em seu navegador!',
  help: 'Dificuldades para permitir acesso?',
};

export default location;
